export const languages = [
  'Français',
  'Anglais',
  'Chinois',
  'Espagnol',
  'Allemand',
  'Portugais',
  'Arabe',
  'Japonais',
  'Russe',
  'Hindi',
];
